class CartController {
  constructor() {
    this.drawer = document.getElementById('CartDrawer');
    this.cartPage = document.getElementById('CartPage');
    this.overlay = document.getElementById('CartDrawerOverlay');
    this.closeBtn = document.getElementById('CartDrawerClose');
    this.cartTriggers = document.querySelectorAll('.header__cart');
    
    this.init();
  }

  init() {
    // Toggle events
    this.cartTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }

    // Cart action events (Delegated)
    document.addEventListener('click', (e) => {
      const isCloseBtn = e.target.closest('#CartDrawerClose');
      const isQtyBtn = e.target.closest('.qty-btn');
      const isRemoveBtn = e.target.closest('.cart-item__remove') || e.target.closest('.cart-page-item__remove');
      const isAtcBtn = e.target.closest('.rec-card__atc');
      const isPrevBtn = e.target.closest('.rec-nav-btn.prev');
      const isNextBtn = e.target.closest('.rec-nav-btn.next');

      if (isCloseBtn) {
        this.close();
      }

      if (isQtyBtn) {
        const btn = e.target.closest('.qty-btn');
        this.updateQuantity(btn.dataset.id, btn.dataset.qty);
      }
      
      if (isRemoveBtn) {
        e.preventDefault();
        const btn = e.target.closest('a');
        this.updateQuantity(btn.dataset.id, 0);
      }

      if (isAtcBtn) {
        const btn = e.target.closest('.rec-card__atc');
        this.addToCart(btn.dataset.variantId);
      }

      if (isPrevBtn) {
        const recSlider = document.querySelector('#CartDrawer .recommendations__slider');
        if (recSlider) recSlider.scrollBy({ left: -455, behavior: 'smooth' });
      }

      if (isNextBtn) {
        const recSlider = document.querySelector('#CartDrawer .recommendations__slider');
        if (recSlider) recSlider.scrollBy({ left: 455, behavior: 'smooth' });
      }
    });

    document.addEventListener('change', (e) => {
      const isVariantSelect = e.target.closest('.rec-variant-selector');
      if (isVariantSelect) {
        const select = e.target;
        const card = select.closest('.rec-card');
        const atcBtn = card.querySelector('.rec-card__atc');
        if (atcBtn) {
          atcBtn.dataset.variantId = select.value;
        }
      }
    });
  }

  open() {
    if (!this.drawer) return;
    this.drawer.classList.add('is-open');
    this.overlay.classList.add('is-open');
    this.drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
  }

  close() {
    if (!this.drawer) return;
    this.drawer.classList.remove('is-open');
    this.overlay.classList.remove('is-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
  }

  async updateQuantity(id, qty) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, quantity: qty })
      });
      
      if (response.ok) {
        this.refreshCart();
      }
    } catch (error) {
      console.error('Cart update error:', error);
    }
  }

  async addToCart(id) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }] })
      });
      
      if (response.ok) {
        this.refreshCart();
        this.open();
      }
    } catch (error) {
      console.error('Add to cart error:', error);
    }
  }

  async refreshCart() {
    try {
      // If we are on the cart page, it's often better to just reload to ensure all subtotals update correctly
      if (window.location.pathname.includes('/cart')) {
        window.location.reload();
        return;
      }

      const cartResponse = await fetch(window.location.pathname);
      const cartHtml = await cartResponse.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(cartHtml, 'text/html');
      
      // Update Drawer if exists
      if (this.drawer) {
        const newDrawer = doc.getElementById('CartDrawer');
        if (newDrawer) this.drawer.innerHTML = newDrawer.innerHTML;
      }

      // Update Header counts
      const newHeaderCounts = doc.querySelectorAll('.header__cart-count');
      const currentHeaderCounts = document.querySelectorAll('.header__cart-count');
      
      currentHeaderCounts.forEach((count, i) => {
        if (newHeaderCounts[i]) {
          count.textContent = newHeaderCounts[i].textContent;
          count.style.display = 'block';
        } else {
          count.style.display = 'none';
        }
      });
    } catch (error) {
      console.error('Refresh cart error:', error);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.cartController = new CartController();
});
